module.exports = __webpack_public_path__ + "static/media/default_user.8af1242f.png";